var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgArrowLeftRounded = function SvgArrowLeftRounded(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "currentColor",
    d: "M9.625 14.375a.53.53 0 0 1 0-.719l6-6a.53.53 0 0 1 .719 0 .53.53 0 0 1 0 .719L10.687 14l5.657 5.656a.53.53 0 0 1 0 .719.53.53 0 0 1-.719 0z"
  })));
};
export default SvgArrowLeftRounded;